import { type ReactNode, useCallback } from 'react';

import ModuleImpressionEvent, {
  type ModuleDisplayType,
  type ModuleIdentity
} from '~/events/ModuleImpressionEvent';
import useImpression from '~/hooks/useImpression';
import useRootData from '~/hooks/useRootData';
import useUser from '~/hooks/useUser';

type Props = ModuleIdentity & {
  children: ReactNode;
  columnCount?: number;
  displayType?: ModuleDisplayType;
  itemCount?: number;
  modulePosition?: number;
};

export default function ModuleImpression({
  children,
  columnCount,
  displayType,
  entityId,
  itemCount,
  modulePosition,
  moduleType
}: Props) {
  const { isBot } = useRootData();
  const { guestId } = useUser();

  const track = useCallback(() => {
    new ModuleImpressionEvent({
      ...({ entityId, moduleType } as ModuleIdentity),
      columnCount,
      displayType,
      guestId,
      isBot,
      itemCount,
      modulePosition
    }).track();
  }, [
    columnCount,
    displayType,
    entityId,
    guestId,
    isBot,
    itemCount,
    modulePosition,
    moduleType
  ]);

  const impressionRef = useImpression<HTMLDivElement>(track, {
    enabled: !isBot
  });

  return <div ref={impressionRef}>{children}</div>;
}
